/**
 * @file template-preview.ts
 * @description Превью шаблона документа на демо-данных (phase19.7; вынесено
 * из окна редактирования в phase19.31, часть 3 — окно ≤ 200 строк).
 *
 * Подставляет в HTML шаблона демо-значения переменных и разворачивает
 * «Таблицу позиций» `{{#each items}}` двумя демо-строками. Прочие
 * переменные — «[—]», чтобы было видно, где они стоят.
 */

const DEMO_ITEMS = [
  { index: "1", name: "Сила жизни, 50 г", quantity: "2", price: "450,00", total: "900,00", vatRate: "0" },
  { index: "2", name: "Медовая пастила", quantity: "1", price: "600,00", total: "600,00", vatRate: "0" },
] as const;

type DemoItem = (typeof DEMO_ITEMS)[number];

/** Демо-значения переменных шаблона — реестром, новая переменная = запись. */
const DEMO_VALUES: Record<string, () => string> = {
  "document.number": () => "ДЕМО-2026-000001",
  "document.issuedAt": () => new Date().toLocaleDateString("ru-RU"),
  "document.totalGross": () => "12 345,00",
  "document.currency": () => "₽",
  "seller.legalName": () => "ИП Чайбери",
  "seller.inn": () => "123456789012",
  "seller.legalAddress": () => "г. Челябинск, ул. Демо, 1",
  "seller.signerName": () => "Иванова И. И.",
  "buyer.name": () => "ООО Покупатель",
};

export function previewTemplateHtml(htmlSource: string): string {
  const withItems = htmlSource.replace(/\{\{#each items\}\}([\s\S]*?)\{\{\/each\}\}/g, (_match, inner: string) =>
    DEMO_ITEMS.map((item) =>
      inner.replace(/\{\{(index|name|quantity|price|total|vatRate)\}\}/g, (_m, key: string) => item[key as keyof DemoItem]),
    ).join(""),
  );
  return withItems.replace(/\{\{\s*([^}#/\s]+)\s*\}\}/g, (_m, key: string) => DEMO_VALUES[key]?.() ?? "[—]").replace(/\{\{[^}]+\}\}/g, "[—]");
}
